
import GmailDoc from "./GmailDoc";
import ShopifyDoc from "./ShopifyDoc";
import RDStationDoc from "./RDStationDoc";

export default {GmailDoc, ShopifyDoc, RDStationDoc}